/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('BibliotecaAdminController', BibliotecaAdminController);

    /* @ngInject */
    function BibliotecaAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                       ModalService, Biblioteca, letras) {
        var vm = this;

        vm.letras = letras;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });


        vm.item = Biblioteca;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            letra: $stateParams.letra


        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {ciudad: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Biblioteca.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.biblioteca.delete.name',
                                body: 'admin.biblioteca.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        }

    }

})(angular);
